export * from "./ToteBetsApiPlaceBetRequest";
export * from "./ToteBetsApiPlaceBetResponse";
export * from "./ToteBetsApiBetRequest";
export * from "./ToteBetsApiBetResponse";
export * from "./ToteBetsApiBetDeclineReason";
export * from "./ToteBetsApiCalculateBetsBet";
export * from "./ToteBetsApiCalculateBetsRequest";
export * from "./ToteBetsApiCalculateBetsResponse";
export * from "./ToteBetsApiCalculationTarget";
export * from "./ToteBetsApiPrecalculateRequest";
export * from "./ToteBetsApiPrecalculateResponse";
export * from "./ToteBetsApiSelection";
//# sourceMappingURL=index.js.map